import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import useAuth from './context/AuthContext';
import LocalStorageService from './services/localStorage';

import Projetos from './pages/Projetos';
import DashboardPage from './pages/DashboardPage';
import Cadastros from './pages/Cadastros';
import Fechamentos from './pages/Fechamentos';
import Importacoes from './pages/Importacoes';
import Login from './pages/Login';
import RecoveryPage from './pages/Login/RecoveryPage';
import ConfirmRegisterPage from './pages/Login/ConfirmRegisterPage';
import Relatorios from './pages/Relatorios';
import Simulacoes from './pages/Simulacoes';
import RelatoriosDelivery from './pages/RelatoriosDelivery';
import BoasVindas from './pages/BoasVindas';
import PaineldeControle from './pages/PaineldeControle';
import Forecast from './pages/Forecast';
import Manutencao from './pages/PaginasAuxiliares/Manutencao';

const manutencao = process.env.REACT_APP_MANUTENCAO_CONVERT || "OFF";

/** Sistema de rotas validando usuário */
function PrivateRoute({ component: Component, ...rest }) {   
    const { token } = LocalStorageService.getUserDataLocal();
    const { user } = useAuth();

    //if (!token) return <Redirect path='*' to='/login' />;
    if(manutencao == "OFF"){
        if (!token) return <Redirect path='*' to='/login' />;
    }

    const resource_access = user?.roles['convert-api'] ? user?.roles['convert-api']['roles'] : [];
    const hasRole = rest.allowedRoles
        ? resource_access.some(item => rest.allowedRoles.includes(item))
        : resource_access.some(item => item === rest.path.split('/')[1]);
    const isManutencaoUser = resource_access.includes("manutencao");

    if (manutencao == "ON") {
         if (!isManutencaoUser) {
            return <Redirect to="/manutencao" />;
        }
    }

    if (!hasRole) {
        return <Route path='/' component={BoasVindas} />
    }

    return (
        <Route
            {...rest}
            render={props => (!!user)
                ? <Component {...props} user={user} />
                : <Redirect to="/login" {...props} />
            }
        />
    )
}

/** Roteador padrão chamando também rotas privadas */
function Routes() {
    // const { user } = LocalStorageService.getUserDataLocal();
    // const { user } = useAuth();



    return (
        <Switch>
            {manutencao == "ON" && <Route path='/manutencao' component={Manutencao}/>}
            <Route path='/login' component={Login}/>
            <PrivateRoute path='/recover/:token' exact component={RecoveryPage} />
            <PrivateRoute path='/register/:token' exact component={ConfirmRegisterPage} />
            <PrivateRoute path="/boas-vindas" exact component={BoasVindas} />
            <PrivateRoute path='/projetos' component={Projetos} />
            <PrivateRoute path='/dashboard' component={DashboardPage} />
            <PrivateRoute path='/cadastros' component={Cadastros} />
            <PrivateRoute path='/simulacoes' component={Simulacoes} />  
            <PrivateRoute path='/fechamentos' component={Fechamentos} />
            {/* <PrivateRoute path='/importacoes' component={Importacoes} /> */}
            <PrivateRoute path='/relatorios' component={Relatorios} />
            <PrivateRoute path='/relatorios-delivery' component={RelatoriosDelivery} />
            <PrivateRoute path='/forecast' component={Forecast} allowedRoles={['forecast', 'forecast-admin']} />
            <PrivateRoute path='/painel-controle' component={PaineldeControle} />

            <Redirect path='*' to='/login' />
        </Switch>
    )
}

export default Routes;
